import React from 'react';
import styles from "./Address.module.sass";
import TitleSection from "../../TitleSection/TitleSection";
import Input from "../../ui/Input/Input";
import theme from "../../../App.module.sass";
import api from "../../../utils/api";
import validation from "../../../utils/validation";
import masks from "../../../utils/masks";
import AppContext from "../../../contexts/appContext";

class Address extends React.Component {

  targetDiv = React.createRef();

  static contextType = AppContext;

  state = {
    cep: '',
    street: '',
    number: '',
    complement: '',
    district: '',
    city: '',
    uf: '',
    invalidCep: false
  };

  newInfo = false;

  fillAddress = (cep, ibc) => {
    api.get(api.endpoints.CEP, {cep}).then((result) => {
      this.newInfo = !(ibc === true);
      this.setState({
        cep: cep,
        street: result.data.logradouro,
        district: result.data.bairro,
        city: result.data.cidade,
        uf: result.data.uf,
        number: '',
        complement: '',
        invalidCep: false
      })
    }).catch(() => {
      this.setState({
        cep: cep,
        street: '',
        district: '',
        city: '',
        uf: '',
        number: '',
        complement: '',
        invalidCep: true
      })
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.newInfo) {
      this.targetDiv.scrollIntoView({behavior: "smooth", block: "start"});
      this.newInfo = false;
    }

    if (this.props.hasOwnProperty('onChange')) {
      this.props.onChange({...this.state});
    }
  }

  componentDidMount() {
    if (this.context.ibc) {
      this.setState({
        cep: this.context.ibcUser.endereco.cep,
      });
      if (validation.cep(this.context.ibcUser.endereco.cep).valid) {
        this.fillAddress(this.context.ibcUser.endereco.cep, this.context.ibc);
      }
    } else if (this.props.data.origem.cotista && this.props.data.pessoa.endereco) {
      const personAddress = this.props.data.pessoa.endereco;
      this.setState({
        cep: personAddress.cep != null ? personAddress.cep : '',
        street: personAddress.logradouro || '',
        number: personAddress.numero || '',
        complement: personAddress.complemento || '',
        district: personAddress.bairro || '',
        city: personAddress.cidade || '',
        uf: personAddress.estado != null ? personAddress.estado : '',
      });
    }
  }

  render() {
    return (
      <section className={styles.sectionForm}>
        <TitleSection title={this.props.pf ? "Seu endereço" : "Endereço da empresa"}/>

        <div className={[theme.row, styles.cepRow].join(' ')}>
          <Input
            className={theme.col33}
            mask={masks.cep}
            value={this.state.cep}
            onChange={(value) => {
              value = masks.numberOnly(value).substr(0, 8);
              value.length === 8 && value !== this.state.cep && this.fillAddress(value);
              this.setState({cep: value});
            }}
            typeDocument={"CEP"}
            errorMsg={"Informe um CEP válido"}
            isValid={!this.state.invalidCep}
            validationRules={[validation.required, validation.cep]}
          />

        </div>

        {
          this.state.uf != null && this.state.uf.length > 0 ?
            (
              <div ref={(el) => this.targetDiv = el}>
                <div className={theme.row}>
                  <Input
                    className={theme.col70}
                    value={this.state.street}
                    onChange={(value) => this.setState({street: value})}
                    typeDocument={"Endereço"}
                    validationRules={[validation.required]}
                    maxLength={30}
                  />
                  <Input
                    className={theme.col30}
                    value={this.state.number}
                    onChange={(value) => this.setState({number: value})}
                    typeDocument={"Número"}
                    mask={masks.numberOnly}
                    validationRules={[validation.required]}
                    maxLength={6}
                  />
                </div>

                <div className={theme.row}>
                  <Input
                    className={theme.col50}
                    value={this.state.complement}
                    onChange={(value) => this.setState({complement: value})}
                    typeDocument={"Complemento"}
                    validationRules={[validation.required]}
                    maxLength={30}
                  />
                  <Input
                    className={theme.col50}
                    value={this.state.district}
                    onChange={(value) => this.setState({district: value})}
                    typeDocument={"Bairro"}
                    validationRules={[validation.required]}
                  />
                </div>

                <div className={theme.row}>
                  <Input className={theme.col70}
                         value={this.state.city}
                         readonly
                         typeDocument={"Cidade"}/>
                  <Input className={theme.col30}
                         value={this.state.uf}
                         readonly
                         typeDocument={"UF"}
                  />
                </div>
              </div>
            ) : null
        }
      </section>
    )
  }
}

export default Address;
